import React from 'react'
import InfiniteScroll from "react-infinite-scroll-component";
import {LanguageContext} from "./LanguageContext"

import './Cellular.scss';

import LocalizedStrings from 'react-localization';

const extensions = require("./extensions")

let strings = new LocalizedStrings({
    en:{
        title:"cellular automaton",
        text1:"CHAOSANDORDERAND",
        text2:"EMERGENCE",
        description:"a cellular automaton arranges the characters through the application of extremely simple rules. however they create complex patterns."
    },
    de: {
        title:"zellulärer automat",
        text1:"CHAOSUNDORDNUNGUND",
        text2:"EMERGENZ",
        description:"ein zellulärer automat arangiert die zeichen durch die anwendung extrem simpler regeln, die jedoch komplexe muster erzeugen."
    }
});

class Cellular extends React.Component {
    state = {lines:[]}

    constructor(props) {
        super(props)
        this.possibleRules = [30, 45, 86, 101, 135, 149]
        this.caResults = []
        this.str = ""
        this.xcount = 90
        this.ycount = 120
        this.f = []
        this.ruleNr = 30
        this.strPos = 0

        this.display = React.createRef()
    }

    componentDidMount() {

        this.reset()

        this.newLines(this.ycount)

        this.props.onchangePoemInfo(strings)
    }

    componentWillReceiveProps(props) {
        const { language } = this.props;

        if (props.language !== language) {
            strings.setLanguage(props.language)

            this.setState({lines:[]})
            this.reset()

            setTimeout(() => {
                this.newLines(this.ycount)
            }, 10)
        }
    }

    nextCh = () => {
        var c = this.str.substring(this.strPos, this.strPos+1)
        this.strPos = (this.strPos + 1) % this.str.length
        return c
    }

    out = (linesIn) => {
        var lines = []
        linesIn.forEach((lineIn) => {
            var line = ""

            for (var i = 0; i < lineIn.length; i++) {
                var c
                if (lineIn[i] === 1) {
                    c = this.nextCh()
                }
                else {
                    c = '\xA0'
                }
                line += c
            }
            lines.push(line)
        })
        this.setState({lines: this.state.lines.concat(lines)});
    }

    reset = () => {
        this.xcount = this.display.current.offsetWidth / 8.5
        this.str = extensions.randomChoice([strings.text1, strings.text2])

        this.strPos = 0
        this.ruleNr = extensions.randomChoice(this.possibleRules)
        this.f = []
        this.caResults = []

        for (var i = 0; i < this.xcount; i++) {
            this.f[i] = extensions.randomChoice([0,1])
        }
    }

    rule = (a, b, c) => {
        var bitIndex = (a << 2)|(b << 1)|c
        var nr = (1 << bitIndex)

        if ((this.ruleNr & nr) > 0) {
            return 1
        }
        return 0
    }

    newLines = (count) => {
        var lines = []
        for (var j = 0; j < count; j++) {
            var g = []

            for (var i = 1; i < this.f.length-1; i++) {
                g[i] = this.rule(this.f[i-1], this.f[i], this.f[i+1])
            }

            g[0] = this.rule(this.f[this.f.length-1], this.f[0], this.f[1])
            g[this.f.length-1] = this.rule(this.f[this.f.length-2], this.f[this.f.length-1], this.f[0])

            this.f = g
            lines.push(this.f)
        }
        this.out(lines)
    }

    fetchMoreData = () => {
        setTimeout(() => {
            this.newLines(12)
        }, 10);
    };

    render() {
        strings.setLanguage(this.context.language)

        return <div className="textDisplay" ref={this.display}>
            <InfiniteScroll
                dataLength={this.state.lines.length}
                next={this.fetchMoreData}
                hasMore={true}
                loader={<h4>loading...</h4>}
            >
                {this.state.lines.map((line, index) => (
                    <p className="cellular" key={index}>{line}</p>
                ))}
            </InfiniteScroll>
        </div>
    }
}
Cellular.contextType = LanguageContext

export default Cellular
